import { handleActions } from 'redux-actions';
import { assocPath, map, path, pathEq, pipe, replace } from 'ramda';

import {
  requestReports,
  requestReportsSuccess,
  requestReportsFailure,
} from 'store/actionCreators/reports/recent';
import { requestObservationUpdateSuccess } from 'store/actionCreators/deviceStatuses';

const defaultState = {};

export default handleActions(
  {
    [requestReports]: (state, { payload: { patientId } }) =>
      assocPath([patientId, 'loading'], true, state),
    [requestReportsSuccess]: (
      state,
      {
        payload: { response },
        meta: {
          primaryPayload: { patientId },
        },
      },
    ) =>
      pipe(
        assocPath([patientId, 'loading'], false),
        assocPath([patientId, 'data'], response),
      )(state),
    [requestReportsFailure]: (state, { primaryPayload: { patientId } }) =>
      assocPath([patientId, 'loading'], false, state),

    [requestObservationUpdateSuccess]: (state, { payload, meta: { primaryPayload } }) => {
      const patientId = pipe(
        path(['data', 'subject', 'reference']),
        replace('Patient/', ''),
      )(primaryPayload);
      const component = path(['response', 'component'])(payload);
      const observationId = path(['response', 'id'])(payload);

      return assocPath(
        [patientId, 'data', 'entry'],
        pipe(
          path([patientId, 'data', 'entry']),
          map(item => {
            if (pathEq(['resource', 'id'], observationId)(item)) {
              return assocPath(['resource', 'component'], component)(item);
            }
            return item;
          }),
        )(state),
        state,
      );
    },
  },
  defaultState,
);
